export default "__VITE_ASSET__DEebABye__"